module.exports = __webpack_public_path__ + "img/61b7628.jpg";